/**
 * Call this in startup this way:
 * if(__DEV__){
 *  initializeDebugLogger();
 * }
 *
 * For android run `adb reverse tcp:9090 tcp:9090` to get it work!
 * ADB is located at `C:\Users\[Username]\AppData\Local\Android\Sdk\platform-tools`
 */
export function initializeDebugLogger() {
    // Nothing to do
}
export function debugLog() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    console.log(args);
}
export function debugWarn(message) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    console.warn(message, args);
}
export function debugError(message) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    console.error(message, args);
}
//# sourceMappingURL=DebugLogger.js.map